import { LineString, MultiLineString, MultiPoint, MultiPolygon, Point, Polygon } from 'geojson';
import { Resource } from './resource';

export interface Device extends Resource {
  category: DeviceCategory[];
  controlledProperty: string[];
  dateLastValueReported: string;
  location: Point | MultiPoint | LineString | MultiLineString | Polygon | MultiPolygon;
  serialNumber: string;
  value: number | ActuatorValue | ComplexValue;
  name: string;
  configuration?: DeviceConfiguration;
  attachedTo?: AttachedTo;

  /**
   *  only if category is actuator
   */
  action?: DeviceAction;

  /**
   *  Equals dateLastValueReported, just used for displaying in component
   */
  dateForDisplay: string;
  deviceState: DeviceState;

  /**
   * Array of last 10 reported images. The array is a sorted queue, i.e., the newest image is at index 0.
   */
  imageFeed: Media[];

  /**
   *  only if it is WeatherSensors
   */
  source?: string;
  precipitation?: Number;
}

export interface DeviceAction {
  status: ActionStatus;
  desiredValue: 'OPEN' | 'CLOSE' | number;
}

export enum ActionStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  TIMEOUT = 'TIMEOUT'
}

export type ActuatorValue = 'OPEN' | 'CLOSED';

export interface ComplexValue {
  mediaType: string;
  url: string;
}

export enum DeviceCategory {
  SENSOR = 'sensor',
  ACTUATOR = 'actuator',
  MEDIA = 'media'
}

export interface AttachedTo {
  attachedToType: string;
  attachedToId: string;
}

export enum DeviceState {
  OK = 'OK',
  WARNING = 'WARNING',
  ALARM = 'ALARM',
  INVALID = 'INVALID',
  OFFLINE = 'OFFLINE'
}

export interface DeviceConfiguration {
  [key: string]: string | number;
  reportingInterval: number;
}

export interface Media {
  mediaType: string;
  url: string;
}
